import { Form, InputGroup, Card } from "react-bootstrap";
import { useEffect, useRef } from "react";

const styles = {
  searchContainer: {
    backgroundColor: "var(--color-background-3)",
  },
  searchInput: {
    fontSize: "1.1rem",
    padding: "0.75rem",
  },
};

function BuscadorFichas({ busqueda, setBusqueda, buscando, error, onSubmit }) {
  const inputRef = useRef(null);

  // Mantener foco siempre, excepto cuando está disabled
  useEffect(() => {
    if (!buscando && inputRef.current) {
      inputRef.current.focus();
    }
  });

  return (
    <Card className="p-4 shadow-sm border" style={styles.searchContainer}>
      <p className="h3 mb-3">Buscador de Fichas</p>

      <Form onSubmit={onSubmit}>
        <InputGroup className="mb-3">
          <InputGroup.Text>
            <i className="bi bi-search"></i>
          </InputGroup.Text>

          <Form.Control
            ref={inputRef}
            type="text"
            placeholder="Buscar por nombre del estudiante (mín. 3 caracteres)..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            style={styles.searchInput}
            disabled={buscando}
          />

          {buscando && (
            <InputGroup.Text>
              <span className="spinner-border spinner-border-sm"></span>
            </InputGroup.Text>
          )}
        </InputGroup>
      </Form>

      {error && (
        <div className="alert alert-warning mb-3" role="alert">
          {error}
        </div>
      )}
    </Card>
  );
}

export default BuscadorFichas;